import React from 'react'
import PropTypes from 'prop-types'
import { CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'

const ACCENT_BORDER = 'rgba(94, 66, 255, 0.35)'
const ACCENT_GRADIENT = 'linear-gradient(135deg, rgba(94, 66, 255, 0.05), rgba(48, 147, 255, 0.05))'
const ICON_GRADIENT = 'linear-gradient(135deg, #6242ff, #3093ff)'

const EmptyStatePanel = ({
  icon,
  title,
  message,
  actionLabel,
  onAction,
  actionColor = 'link',
  actionVariant,
  actionSize = 'sm',
  className = '',
}) => (
  <div
    className={`d-flex align-items-center gap-3 rounded-3 shadow-sm bg-white bg-opacity-75 px-3 py-2 w-100 ${className}`}
    style={{
      borderLeft: `4px solid ${ACCENT_BORDER}`,
      background: ACCENT_GRADIENT,
      minHeight: '80px',
    }}
  >
    {icon ? (
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm flex-shrink-0"
        style={{
          width: '26px',
          height: '26px',
          background: ICON_GRADIENT,
          color: '#ffffff',
        }}
        aria-hidden="true"
        role="img"
      >
        <CIcon icon={icon} size="sm" />
      </span>
    ) : null}
    <div className="d-flex flex-column flex-grow-1">
      {title ? (
        <small
          className="text-uppercase fw-semibold"
          style={{ fontSize: '0.6rem', color: '#6242ff' }}
        >
          {title}
        </small>
      ) : null}
      {message ? (
        <span
          className="text-muted"
          style={{ fontSize: '0.68rem', color: '#3a4a6b', display: 'block', marginTop: '0.25rem' }}
        >
          {message}
        </span>
      ) : null}
    </div>
    {actionLabel && typeof onAction === 'function' ? (
      <CButton
        color={actionColor}
        variant={actionVariant}
        size={actionSize}
        className="p-0 text-decoration-none flex-shrink-0"
        onClick={onAction}
      >
        {actionLabel}
      </CButton>
    ) : null}
  </div>
)

EmptyStatePanel.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  title: PropTypes.node,
  message: PropTypes.node,
  actionLabel: PropTypes.node,
  onAction: PropTypes.func,
  actionColor: PropTypes.string,
  actionVariant: PropTypes.string,
  actionSize: PropTypes.string,
  className: PropTypes.string,
}

export default EmptyStatePanel
